<template lang="pug">
    div
        .form__title
            slot(name='title')
        form.form__body(action='javascript://' v-if='params')
            form-tabs(
                v-if="templateHasDays || homeworkHasAtLeastTwoDates",
                elements-type="homework"
                :tabs-number="tabsNumber",
                :same-settings-are-active="false",
                :disable-name-change="true"
                :custom-tab-names="customTabNames"
                @setCurrentTab="num => currentHomeworkTab = num"
                @wrongTabsAmount="equalizeDaysToDates"
            )
            .form__field(v-if="gameMode !== 'course'")
                label.form__label
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_category') }}
                .form__field-body
                    cs-multiselect(
                        :multiple='false',
                        :options='categories',
                        :show-labels='false',
                        :allow-empty='false',
                        track-by='value',
                        label='label',
                        :placeholder="$i18n.t('trainer.trainer_gameFormSetting_category')",
                        v-model='selectedCategory',
                        @select="selectCategory($event.value)",
                        :searchable="false"
                    )
            .form__field(v-if="gameMode !== 'course'")
                label.form__label
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_rule') }}
                .form__field-body
                    cs-multiselect(
                        :multiple='false',
                        :options='selectedCategory.rules',
                        :show-labels='false',
                        :allow-empty='false',
                        track-by='value',
                        label='label',
                        :placeholder="$i18n.t('trainer.trainer_gameFormSetting_rule')",
                        v-model='selectedRule',
                        @select="selectRule($event.value)",
                        :searchable="false"
                    )
            .form__field(v-if="gameMode !== 'generator-settings' && gameMode !== 'course'")
                label.form__label
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_textInput') }}
                .form__field-body
                    div
                        div(v-if="user.type !== 'student'")
                            a.link(@click.prevent="showManualInputModal = true")
                                | {{ changeTextLink }}
                            span &nbsp; {{ $i18n.t('games.games_or') }} &nbsp;
                        a.link(@click.prevent="showSelectTextModal = true") {{ selectString }}
            .form__field(v-if="gameMode !== 'generator-settings' && gameMode !== 'course' && sourceTextWithoutPunctuation.length")
                label.form__label
                .form__field-body
                    | {{ sourceTextWithoutPunctuation.length > 20 ? sourceTextWithoutPunctuation.slice(0, 25) + '...' : sourceTextWithoutPunctuation }}
            .form__field(v-if="!isBattle && !isOlympiad")
                label.form__label
                    |  {{  $i18n.t('trainer.trainer_gameFormSetting_showingCorrectAnswers')  }}
                .form__field-body
                    cs-checkbox(v-model="params.showingCorrectAnswers")
            divider(v-if="gameMode === 'course'")
            slot(v-if="customTabNames.length === 0", name='parameters')
            slot(name='help')
            .form__buttons
                cs-button.form__button(@click='cancel', color="blue", pattern="primary-outline")
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_dontSave') }}
                cs-button.form__button(color="blue", @click='handleGameSave' :disabled="disabledAsNotHavingSource")
                    | {{ !usersIds ? $i18n.t('trainer.trainer_gameFormSetting_saveGame') :  $i18n.t('trainer.trainer_gameFormSetting_saveDifference') }}
        cs-loader(v-else)
        cs-modal(v-if="showManualInputModal", @close="closeManualInputModal")
            div(slot="header") {{ $i18n.t('trainer.trainer_gameFormSetting_manualInput_modalTitle') }}
            .trainer-modal-content__settings
                .trainer-modal-content__setting
                    textarea.textarea.input-area.trainer-modal-content__textarea(
                        v-model="params.sourceText",
                        :placeholder="$i18n.t('trainer.trainer_textsModal_textInput')"
                    )
                .question-answers-block
                    divider
                    div
                        .trainer-modal__save-to-database(v-if="isUserAbleToSaveToDB")
                            cs-checkbox(
                                @click.native.prevent="saveToDB = !saveToDB",
                                v-model="saveToDB",
                                :checked="saveToDB",
                                :disabled="editText"
                            )
                                | {{ $i18n.t('trainer.trainer_gameFormSetting_saveTextToDataBaseAsNew') }}
                        .trainer-modal__save-to-database(v-if="canUserEditText")
                            cs-checkbox(
                                @click.native.prevent="editText = !editText",
                                v-model="editText",
                                :checked="editText",
                                :disabled="saveToDB"
                            )
                                | {{ $i18n.t('trainer.trainer_gameFormSetting_editText') }}
                        .save-text-relation-selector(v-if="saveToDB || editText")
                            cs-multiselect.text-settings__select(
                                :multiple='false'
                                :options='typesOfRelations'
                                :show-labels='false'
                                :allow-empty='false'
                                :custom-label='getRelationName'
                                :placeholder="$i18n.t('trainer.trainer_textsRelationSelector')"
                                v-model='relation'
                                :searchable='false'
                                v-validate="'required'"
                                name='relation'
                                :data-vv-as="$i18n.t('trainer.trainer_textsRelationSelector')"
                            )
                            cs-multiselect.text-settings__select(
                                :multiple="true",
                                open-direction="top",
                                :options="relationItems",
                                :show-labels="false",
                                label="name",
                                track-by="id",
                                :loading="loadingRelationItems",
                                :placeholder="relationItemsPlaceholder",
                                v-model="selectedRelationItems",
                                :disabled="!relationItems.length",
                                @open="getRelationItems"
                            )
                                span(slot="noResult") {{ $i18n.t('fields.fields_gradeNotFound') }}
            div.trainer-modal__footer.trainer-modal-button
                cs-button(
                    @click="saveManualInputModal",
                ) {{ $i18n.t('trainer.trainer_gameFormSetting_saveChanges') }}
        cs-modal(v-if="showTextSettings", @close="closeTextSettings")
            div(slot="header") {{ $i18n.t('trainer.trainer_gameFormSetting_accessSettings') }}
            .trainer-modal-content(v-if="user.isSuperadmin")
                .trainer-modal-content__text-settings
                    cs-multiselect.text-settings__select(
                        :multiple='false'
                        :options='typesOfRelations'
                        :show-labels='false'
                        :allow-empty='true'
                        :custom-label='getRelationName'
                        :placeholder="$i18n.t('trainer.trainer_textsRelationSelector')"
                        v-model='relation'
                        :searchable='false'
                        v-validate="'required'"
                        name='relation'
                        :data-vv-as="$i18n.t('trainer.trainer_textsRelationSelector')"
                    )
                    cs-multiselect.text-settings__select(
                        :multiple="true",
                        :options="relationItems",
                        :show-labels="false",
                        label="name",
                        track-by="id",
                        :loading="loadingRelationItems",
                        :placeholder="relationItemsPlaceholder",
                        v-model="selectedRelationItems",
                        :disabled="!relation || !relationItems.length",
                        @open="getRelationItems"
                    )
                        span(slot="noResult") {{ $i18n.t('fields.fields_gradeNotFound') }}
                .trainer-modal-content__footer
                    cs-button.trainer-modal-content__footer-button(@click="backToShowSelectTextModal")
                        | {{ $i18n.t('trainer.trainer_browseGames_back') }}
                    cs-button.trainer-modal-content__footer-button(@click="updateTextSettings", :disabled="relation && !selectedRelationItems.length")
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_saveChanges') }}
        confirm-delete-modal(
            v-if="showDeleteTextModal",
            @close="showDeleteTextModal = false"
            @delete="deleteText"
        ) {{ " " + $i18n.t('list.list_templatePreview_thisText') }}
            div(slot="header") {{ $i18n.t('modal.modal_confirmDelete_confirmation') }}
        cs-modal(v-if="showSelectTextModal", @close="closeSelectTextModal")
            div(slot="header") {{ $i18n.t('trainer.trainer_gameFormSetting_selectModal_modalTitle') }}
            .trainer-modal-content
                .trainer-modal-content__settings
                    .trainer-modal-content__setting
                        .trainer-modal-content__search-input
                            cs-input(
                                :placeholder="$i18n.t('trainer.trainer_gameFormSetting_searchForText')",
                                v-model="searchTextName",
                            )
                            svg-icon.search-icon(size="large", name="search")
                .trainer-modal-content__noTextsMessage(
                    v-if="filteredTexts.length === 0",
                    v-text="$i18n.t('trainer.trainer_gameFormSetting_noTexts')"
                )
                .trainer-modal-content__text-item(
                    v-else
                    v-for="text in filteredTexts"
                    :class=`{
                        'trainer-modal-content__text-item_selected': text.content === params.sourceText,
                        'trainer-modal-content__text-item_opened': isTextOpened(text),
                    }`
                    @click="handleClickOnText(text)"
                )
                    div.trainer-modal-content__text-item__title(
                        :class=`{
                            'trainer-modal-content__text-item__title_selected': text.content === params.sourceText,
                            'trainer-modal-content__text-item__title_closed': !isTextOpened(text)
                        }`
                    )
                        .text-label-block
                            svg-icon.selected-text-icon(v-if="text.content === params.sourceText", name="circle-check", size="big")
                            span.text-label
                                | {{ text.label }}
                        .trainer-modal-content__text-item-actions(v-if="user.type !== 'student'")
                            span.trainer-modal-content__text-item-settings(
                                v-if="user.isSuperadmin",
                                @click.stop="handleTextSettings(text)",
                            )
                                svg-icon(size="small", name="cog")
                            span.trainer-modal-content__text-item-delete(
                                v-if="text.canUserEditText",
                                @click.stop="handleDeleteText(text)",
                            )
                                svg-icon(size="largest", name="cancel")
                            span.trainer-modal-content__text-item__resize__box(@click.stop="setOpenedText(text)")
                                svg-icon(:name="isTextOpened(text) ? 'angle-up' : 'angle-down'", size="large")
                    .text-content(
                        v-if="isTextOpened(text) && user.type !== 'student'",
                        :class="{'text-content_selected': text.content === params.sourceText}"
                    )
                        | {{ text.content }}
</template>

<script>
    import GameFormMixin from '../../../utils/trainer/GameFormMixin';
    import TrainerGames from '../../../config/trainer';
    import { getInitParameters } from '../../../utils/trainer/getInitParameters';
    import { getFormattedDate } from '../../../utils/getFormattedDate';
    import { mapState } from 'vuex';
    import { cloneDeep, find } from 'lodash';
    import multiplayerFormMixin from '../../../utils/multiplayer/formMixin';
    import punctuationMarksGameItemsApi from '../../../api/games/punctuationMarksGameItemsApi';
    import SchoolApi from '../../../api/school';
    import GradeApi from '../../../api/grade';
    import FormTabs from '../shared/FormTabs';
    import ConfirmDeleteModal from '../../../modals/ConfirmDeleteModal';
    const CAPABLE_USER_TYPES = ['admin', 'teacher'];
    const FREE_GAME = 'free-game';

    const capitalize = string => string[0].toUpperCase() + string.slice(1);

    export default {
        components: {
            FormTabs,
            ConfirmDeleteModal,
        },
        props: [
            'slug',
            'courseType',
            'id',
            'usersIds',
            'homeworkId',
            'gameMode',
            'gameId',
            'generatorSettings',
            'generatorGameIndex',
        ],
        mixins: [GameFormMixin, multiplayerFormMixin],
        data() {
            return {
                namesForDays: ['1', '2', '3', '4', '5', '6', '7', '8'],
                params: null,
                showManualInputModal: false,
                showSelectTextModal: false,
                showDeleteTextModal: false,
                texts: [],
                saveToDB: false,
                editText: false,
                selectedTextId: null,
                canUserEditText: null,
                openedText: [],
                relation: '',
                typesOfRelations: ['grade', 'school'],
                relations: {
                    grade: this.$i18n.t('homework.homework_create_grade'),
                    school: this.$i18n.t('homework.homework_create_school'),
                },
                loadingRelationItems: false,
                relationItems: [],
                selectedRelationItems: [],
                showTextSettings: false,
                selectedText: null,
                searchTextName: '',
                currentHomeworkTab: 1,
                selectedCategory: null,
                categories: [
                    {
                        label: this.$i18n.t('trainer.trainer_gameFormSetting_class_1'),
                        value: 'class_1',
                        rules: [
                            {
                                label: this.$i18n.t(
                                    'trainer.trainer_gameFormSetting_narrative_interrogative_motivational_sentences'
                                ),
                                value: 'narrative_interrogative_motivational_sentences',
                            },
                        ],
                    },
                    {
                        label: this.$i18n.t('trainer.trainer_gameFormSetting_class_2'),
                        value: 'class_2',
                        rules: [
                            {
                                label: this.$i18n.t(
                                    'trainer.trainer_gameFormSetting_narrative_interrogative_motivational_sentences'
                                ),
                                value: 'narrative_interrogative_motivational_sentences',
                            },
                        ],
                    },
                    {
                        label: this.$i18n.t('trainer.trainer_gameFormSetting_class_3'),
                        value: 'class_3',
                        rules: [
                            {
                                label: this.$i18n.t(
                                    'trainer.trainer_gameFormSetting_homogeneous_members_of_the_sentence'
                                ),
                                value: 'homogeneous_members_of_the_sentence',
                            },
                            {
                                label: this.$i18n.t('trainer.trainer_gameFormSetting_comma_before_unions'),
                                value: 'comma_before_unions',
                            },
                        ],
                    },
                ],
                selectedRule: null,
            };
        },
        mounted() {
            this.getTexts().then(() => {
                if (this.gameMode === FREE_GAME) {
                    let paramsArray = this.$store.state.trainer.paramsArray;
                    if (paramsArray && paramsArray[0] && paramsArray[0].slug === this.slug) {
                        this.paramsArray = cloneDeep(paramsArray);
                        this.$emit('playersNumber', this.paramsArray.length);
                        this.params = this.paramsArray[0];
                    } else if (this.gamesParameters) {
                        this.$set(
                            this,
                            'params',
                            cloneDeep(
                                getInitParameters({
                                    slug: this.slug,
                                    parameters: {
                                        default: cloneDeep(this.gamesParameters[this.slug]),
                                    },
                                })
                            )
                        );
                    } else {
                        this.params = cloneDeep(TrainerGames.games).find(
                            item => item.slug === this.slug
                        ).parameters.default;
                    }
                } else {
                    this.setInitParams(this.getKey(this.usersIds));
                }
                this.selectedCategory = find(this.categories, { value: this.params.category });
                this.selectedRule = find(this.selectedCategory.rules, { value: this.params.rule });
                const currentAmountOfDays = this.homework?.dates
                    ? this.homework.dates.length
                    : this.homework?.chosenDaysAmount;

                if (this.params && this.paramsArray?.length !== currentAmountOfDays) {
                    if (this.homework?.chosenDaysAmount > 1 || this.params.settings.days) {
                        this.homework?.games.forEach(game => {
                            if (game.slug === 'PunctuationMarks') {
                                const searchedGameIndex = this.homework.games.findIndex(
                                    homeworkGame => homeworkGame.id === game.id
                                );
                                const searchedParamsIndex = this.paramsArray.indexOf(param => param.id === game.id);
                                this.paramsArray[searchedParamsIndex] = this.homework.games[
                                    searchedGameIndex
                                ].parameters.default;
                            }
                        });

                        if (this.paramsArray.length !== this.homework?.chosenDaysAmount) {
                            while (this.paramsArray.length < this.homework?.chosenDaysAmount) {
                                let counter = 0;
                                this.paramsArray.push(cloneDeep(this.params));
                                this.params = this.paramsArray[counter];
                                counter++;
                            }

                            while (this.paramsArray.length > currentAmountOfDays) {
                                this.cropParamsArrayToNeededLength();
                            }
                        }
                    }
                    if (this.homework?.dates?.length > 1) {
                        while (this.paramsArray.length < currentAmountOfDays) {
                            this.paramsArray.push(
                                cloneDeep(
                                    getInitParameters({
                                        slug: this.slug,
                                        parameters: {
                                            default: cloneDeep(this.gamesParameters[this.slug]),
                                        },
                                    })
                                )
                            );
                            const paramsArrayLastIndex = this.paramsArray.length - 1;
                            this.paramsArray[paramsArrayLastIndex].dueDate = getFormattedDate(
                                this.homework.dates[paramsArrayLastIndex],
                                'YYYY-MM-DD'
                            );
                        }
                        while (this.paramsArray.length > currentAmountOfDays) {
                            this.cropParamsArrayToNeededLength();
                        }
                        this.params = this.paramsArray[0];
                    }
                }
            });
        },
        computed: {
            ...mapState({
                homework: state => state.trainer.homework,
                gamesParameters: state => state.trainer.gamesParameters,
                user: state => state.auth.user,
                isBattle: state => !!state.battle.battle,
                isOlympiad: state => !!state.olympiad.olympiad,
            }),
            tabsNumber() {
                return this.templateHasDays ? this.params.settings.days : this.homework.dates.length;
            },
            homeworkHasAtLeastTwoDates() {
                return this.homework?.dates?.length > 1;
            },
            templateHasDays() {
                return this.params.settings.days > 1;
            },
            filteredTexts() {
                let result = this.texts;
                if (this.searchTextName) {
                    result = result.filter(({ label }) => new RegExp(this.searchTextName, 'i').test(label));
                }
                if (this.selectedRule) {
                    result = result.filter(({ rule }) => rule === this.selectedRule.value);
                }
                if (this.selectedCategory) {
                    result = result.filter(({ category }) => category === this.selectedCategory.value);
                }
                return result;
            },
            selectString() {
                let str = this.$i18n.t('games.games_gameSettings_selectFromLoaded');
                return this.user.type === 'student' ? str.charAt(0).toUpperCase() + str.slice(1) : str;
            },
            disabledAsNotHavingSource() {
                if (this.gameMode === 'course') {
                    return false;
                }
                const paramsArrayIsBiggerThanOne = this.paramsArray.length > 1;
                return this.paramsArray.some(params => {
                    if (params.sourceText) {
                        return false;
                    }
                    return paramsArrayIsBiggerThanOne ? !params.sourceText : !this.params.sourceText.length;
                });
            },
            isUserAbleToSaveToDB() {
                return CAPABLE_USER_TYPES.includes(this.user.type);
            },
            relationItemsPlaceholder() {
                if (this.relation) {
                    return this.$i18n.t('trainer.trainer_textsRelation_items', {
                        itemType:
                            this.relation === 'school'
                                ? this.$i18n.t('declination.declination_school_add')
                                : this.$i18n.t('declination.declination_grade_add'),
                    });
                }
                return this.$i18n.t('trainer.trainer_textsRelationSelector');
            },
            customTabNames() {
                if (this.homework && this.homework.dates?.length > 1) {
                    return this.homework.dates
                        .slice()
                        .reverse()
                        .map(date => {
                            const dateAsClassObject = new Date(date);
                            return (
                                this.addLeadingZeros(dateAsClassObject.getDate()) +
                                '.' +
                                this.addLeadingZeros(dateAsClassObject.getMonth() + 1)
                            );
                        });
                } else if (this.templateHasDays) {
                    return this.namesForDays;
                }
                return [];
            },
            changeTextLink() {
                return this.params.sourceText
                    ? this.$i18n.t('trainer.trainer_gameFormSetting_changeText')
                    : this.$i18n.t('trainer.trainer_gameFormSetting_manualInput');
            },
            sourceTextWithoutPunctuation() {
                if (!this.params.sourceText) {
                    return '';
                }
                return this.removeFromTextPunctuation(this.params.sourceText, this.params.sourceTextCapitalizeWords);
            },
        },
        watch: {
            currentHomeworkTab(value) {
                if (value) {
                    this.params = this.paramsArray[value - 1];
                }
            },
            relation() {
                this.selectedRelationItems = [];
                this.relationItems = [];
                this.getRelationItems();
            },
        },
        updated() {
            if (this.params) {
                this.selectedCategory = find(this.categories, { value: this.params.category });
                this.selectedRule = find(this.selectedCategory.rules, { value: this.params.rule });
            }
        },
        methods: {
            addLeadingZeros(number) {
                return number < 10 ? '0' + number : '' + number;
            },
            cropParamsArrayToNeededLength() {
                this.paramsArray.pop();
                this.params = this.paramsArray[0];
            },
            equalizeDaysToDates(datesAmount) {
                this.params.settings.days = datesAmount;
            },
            backToShowSelectTextModal() {
                this.showSelectTextModal = true;
                this.showTextSettings = false;
            },
            getTexts() {
                return punctuationMarksGameItemsApi.get().then(data => {
                    this.texts = data.map(item => ({
                        ...item,
                        label: this.removeFromTextPunctuation(item.content, item.capitalizeWords),
                    }));
                });
            },
            removeFromTextPunctuation(text, capitalizeWords) {
                const capitalizeWordsSet = new Set(capitalizeWords);
                return capitalize(
                    text
                        .replaceAll(/[,.?!]/g, ' ')
                        .replaceAll(/[\s]+/g, ' ')
                        .trim()
                        .split(' ')
                        .map(word => {
                            const wordWithoutPunctuation = word.replaceAll(/[,.?!]/g, '');
                            return capitalizeWordsSet.has(wordWithoutPunctuation) ? word : word.toLowerCase();
                        })
                        .join(' ')
                );
            },
            closeTextSettings() {
                this.showTextSettings = false;
                this.selectedText = null;
                this.relation = '';
                this.relationItems = [];
            },
            handleTextSettings(text) {
                this.closeSelectTextModal();
                this.showTextSettings = true;
                this.selectedText = text;
                if (this.selectedText.grades && this.selectedText.grades.length) {
                    this.relation = 'grade';
                    this.$nextTick(() => {
                        this.selectedRelationItems = this.selectedText.grades;
                    });
                }
                if (this.selectedText.schools && this.selectedText.schools.length) {
                    this.relation = 'school';
                    this.$nextTick(() => {
                        this.selectedRelationItems = this.selectedText.schools;
                    });
                }
            },
            handleDeleteText(text) {
                this.closeSelectTextModal();
                this.showDeleteTextModal = true;
                this.selectedTextId = text.id;
            },
            async saveManualInputModal() {
                if (this.saveToDB) {
                    this.createNewItem();
                }
                if (this.editText) {
                    this.updateItem();
                }
                this.showManualInputModal = false;
            },
            createNewItem() {
                punctuationMarksGameItemsApi
                    .store({
                        category: this.selectedCategory.value,
                        rule: this.selectedRule.value,
                        content: this.params.sourceText,
                        relation: this.relation,
                        selectedRelationItemsIds: this.selectedRelationItems.map(item => item.id),
                    })
                    .catch(err => this.$toasted.error(err));
            },
            updateItem() {
                punctuationMarksGameItemsApi
                    .update(this.selectedTextId, {
                        category: this.selectedCategory.value,
                        rule: this.selectedRule.value,
                        content: this.params.sourceText,
                        relation: this.relation,
                        selectedRelationItemsIds: this.selectedRelationItems.map(item => item.id),
                    })
                    .catch(err => this.$toasted.error(err));
            },
            async updateTextSettings() {
                try {
                    await punctuationMarksGameItemsApi.update(this.selectedText.id, {
                        category: this.selectedCategory.value,
                        rule: this.selectedRule.value,
                        content: this.selectedText.content,
                        relation: this.relation,
                        selectedRelationItemsIds: this.selectedRelationItems.map(item => item.id),
                    });
                    await this.getTexts();
                    this.showTextSettings = false;
                    this.selectedText = null;
                    this.relation = '';
                    this.relationItems = [];
                } catch (error) {
                    this.showTextSettings = false;
                    this.selectedText = null;
                    this.relation = '';
                    this.relationItems = [];
                    this.$toasted.error(this.$root.$t('errors.error_has_occurred'));
                }
            },
            handleGameSave() {
                !this.usersIds && this.gameMode && this.gameMode === FREE_GAME ? this.saveGameMode() : this.saveGame();
            },
            deleteText() {
                punctuationMarksGameItemsApi
                    .delete(this.selectedTextId)
                    .then(() => {
                        this.$toasted.success(this.$i18n.t('trainer.trainer_gameFormSetting_textDeleted'));
                        const deletedTextIndex = this.texts.findIndex(text => text.id === this.selectedTextId);
                        this.texts.splice(deletedTextIndex, 1);
                    })
                    .catch(err => {
                        this.$toasted.error(err);
                    });
                this.showDeleteTextModal = false;
            },
            clearSourceTextInfo() {
                this.params.sourceText = '';
                this.params.sourceTextCapitalizeWords = [];
                this.saveToDB = false;
                this.editText = false;
                this.relation = '';
                this.selectedRelationItems = [];
            },
            closeManualInputModal() {
                this.clearSourceTextInfo();
                this.showManualInputModal = false;
            },
            closeSelectTextModal() {
                this.clearSourceTextInfo();
                this.showSelectTextModal = false;
            },
            handleClickOnText(text) {
                this.params.sourceText = text.content;
                this.params.sourceTextCapitalizeWords = text.capitalizeWords;
                if (text.schools.length) {
                    this.relation = 'school';
                    this.$nextTick(() => {
                        this.selectedRelationItems = text.schools;
                    });
                } else if (text.grades.length) {
                    this.relation = 'grade';
                    this.$nextTick(() => {
                        this.selectedRelationItems = text.grades;
                    });
                }
                this.showSelectTextModal = false;
                this.saveToDB = false;
                this.editText = false;
                this.canUserEditText = text.canUserEditText;
                this.selectedTextId = text.id;
            },
            isTextOpened({ content }) {
                return content === this.openedText;
            },
            setOpenedText({ content }) {
                this.openedText = this.openedText === content ? null : content;
            },
            getRelationName(relation) {
                return this.relations[relation];
            },
            getRelationItems() {
                if (this.relationItems.length || (!this.selectedText && !this.showManualInputModal)) {
                    return;
                }
                this.loadingRelationItems = true;
                let api = this.relation === 'school' ? SchoolApi : GradeApi;
                let params =
                    this.relation === 'school'
                        ? { all: true, withActiveAccount: true }
                        : {
                              schoolId: this.user.isSuperadmin ? null : this.user.school && this.user.school.id,
                              schoolsIds: this.user.isSuperadmin
                                  ? null
                                  : this.user.schools && this.user.schools.map(school => school.id),
                              status: 'active',
                              all: true,
                              withoutWith: true,
                          };
                api.list(params)
                    .then(data => {
                        let items = this.relation === 'school' ? data.schools : data.grades;
                        this.relationItems = items ? items : [];
                        this.loadingRelationItems = false;
                    })
                    .catch(() => {
                        this.loadingRelationItems = false;
                        this.$toasted.error(this.$root.$t('errors.error_has_occurred'));
                    });
            },
            selectCategory(category) {
                this.params.category = category;
                const selectedCategory = find(this.categories, { value: category });
                this.selectedRule = selectedCategory.rules[0];
                this.params.rule = this.selectedRule.value;
                this.clearSourceTextInfo();
            },
            selectRule(rule) {
                this.params.rule = rule;
                this.clearSourceTextInfo();
            },
        },
    };
</script>

<style lang="scss" scoped>
    .link {
        color: $hsl-color-blue-56;
        text-decoration: underline;
        &:hover {
            color: $hsl-color-blue-56;
            text-decoration: none;
            cursor: pointer;
        }
    }

    .form__title {
        font-weight: 500;
        font-size: 22px;
        line-height: 26px;
        text-align: center;
        margin-bottom: 25px;
    }

    .form__body {
        width: 100%;
        box-sizing: border-box;
        @include media($lg) {
            padding: 0 4.5%;
        }
    }

    .form__field {
        display: flex;
        flex-direction: column;
        margin-bottom: 20px;
        @include media($md) {
            padding: 0 2.5px;
            flex-direction: row;
            align-items: center;
        }
        @include media($lg) {
            padding: 0 10%;
        }
        @include media($xlg) {
            padding: 0 13%;
        }
    }
    .form__label {
        min-width: 0;
        font-size: 16px;
        line-height: 19px;
        margin-right: 20px;
        margin-bottom: 0.5rem;
        @include media($md) {
            width: 10em;
            max-width: 10em;
            margin-bottom: 0;
            text-align: right;
        }
        @include media($xlg) {
            max-width: none;
            min-width: 14em;
        }
    }

    .form__field-body {
        flex-grow: 1;
        max-width: 350px;
        @include media($xl) {
            max-width: inherit;
        }
    }

    .form__field-body--inline {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        justify-content: space-between;
    }

    .form__buttons {
        margin-top: 30px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        @include media($md) {
            flex-direction: row;
        }
    }

    .form__button {
        margin: 10px 50px;
        @include media($md) {
            margin: 0 10px;
        }
    }

    .trainer-modal__footer {
        display: flex;
        button {
            width: 100%;
        }
    }

    .modal-label {
        font-weight: bold;
        padding-right: 8px;
    }

    .trainer-modal-content,
    .trainer-modal-button {
        margin-top: 20px;
    }

    .trainer-modal-content {
        min-height: 50vh;
    }

    .trainer-modal-content__noTextsMessage {
        text-align: center;
        font-size: 24px;
        margin-top: 8%;
    }

    .trainer-modal-content__textarea {
        height: 250px;
        display: block;
        line-height: 1.25;
        max-height: 600px;
        max-width: 100%;
        min-width: 100%;
        padding: 0.8em;
        resize: vertical;
        &_small {
            height: 65px;
            display: block;
            line-height: 1.25;
            max-height: 600px;
            max-width: 100%;
            min-width: 100%;
            padding: 0.8em;
            resize: vertical;
        }
    }

    .answer-block {
        margin-top: 25px;
    }

    .answer-block__items {
        display: flex;
    }

    .answer-block__input {
        width: 100%;
        position: relative;
    }

    .right-answer-checkbox {
        margin-right: 10px;
    }

    .input-area {
        border: 1px solid #bdbdbd;
        box-sizing: border-box;
        border-radius: 5px;
        &:focus,
        &:active {
            outline: none;
        }
        &::placeholder {
            font-weight: lighter;
        }
        @media screen and (max-width: 767px) {
            max-width: 205px;
        }
    }

    .trainer-modal__save-to-database {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .trainer-modal-content__text-item {
        border-radius: 10px;
        cursor: pointer;
        font-weight: normal;
        font-size: 16px;
        line-height: 24px;
        color: #333333;
        box-sizing: border-box;
        max-width: 475px;
        margin: 0 auto 20px auto;
        &_opened {
            border: 1px solid #f2f2ff;
        }
        &_selected {
            background: #f2fff2;
            border: 1px solid #6bbd6c;
        }
    }

    .text-content {
        background: #ffffff;
        border: 1px solid #f2f2ff;
        border-top: none;
        box-sizing: border-box;
        border-radius: 0 0 10px 10px;
        &_selected {
            background: #f2fff2;
        }
    }

    .trainer-modal-content__text-item__title {
        padding: 20px;
        border-radius: 10px;
        border: 1px solid #f2f2ff;
        background: #f2f2ff;
        font-size: 16px;
        display: flex;
        justify-content: space-between;
        gap: 10px;
        &_selected {
            background: #f2fff2;
            border-bottom: 1px solid #6bbd6c;
        }
        &_closed {
            border-bottom: none;
        }
    }

    .trainer-modal-content__text-item__resize__box {
        content: '';
        position: relative;
        top: 0.2rem;
        left: 0.4rem;
        width: 1.2rem;
        min-width: 1.2rem;
        height: 1.2rem;
        display: flex;
        justify-content: center;
        align-items: center;
        color: $hsl-color-blue-56;
    }

    .trainer-modal-content__text-item-settings {
        display: flex;
        align-items: center;
        justify-content: center;
        color: $hsl-color-blue-56;
        border: 1px solid $hsl-color-blue-56;
        border-radius: 50%;
        width: 30px;
        height: 30px;
        &:hover {
            background: $hsl-color-blue-56;
            color: #ffffff;
        }
    }

    .trainer-modal-content__text-item-delete {
        display: flex;
        margin-left: 5px;
        align-items: center;
        justify-content: center;
        color: $hsl-color-blue-56;
        border: 1px solid $hsl-color-blue-56;
        border-radius: 50%;
        width: 30px;
        height: 30px;
        &:hover {
            background: $hsl-color-blue-56;
            color: #ffffff;
        }
    }

    .trainer-modal-content__text-item-actions {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .save-text-relation-selector {
        margin-top: 0.5rem;
    }

    .trainer-modal-content__settings {
        max-width: 475px;
        margin: 0 auto;
    }

    .trainer-modal-content__setting {
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 20px 0;
        position: relative;
        &:last-child {
            margin-bottom: 30px;
            justify-content: space-between;
        }
        &:first-child {
            justify-content: space-between;
        }
        @media screen and (max-width: 767px) {
            flex-direction: column;
            text-align: left;
            align-items: stretch;
        }
    }

    .text-settings {
        max-width: 320px;
        margin-left: 20px;
        @media screen and (max-width: 767px) {
            margin-left: 0;
        }
    }

    .trainer-modal-content__search-input {
        width: 100%;
    }

    .search-icon {
        right: 15px;
        position: absolute;
        top: 25%;
        color: #bdbdbd;
        cursor: pointer;
    }

    .text-settings__select {
        margin: 20px 0;
    }

    .text-label-block {
        font-weight: 500;
        font-size: 20px;
        line-height: 24px;
        color: #333333;
        display: flex;
        align-items: center;
        overflow: hidden;
    }

    .text-label {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .trainer-modal-content__text-item__content {
        font-size: 16px;
        line-height: 24px;
        color: #333333;
        text-align: left;
        padding: 0 10px 0 10px;
        &:first-child {
            padding-top: 20px;
        }
    }

    .trainer-modal-content__text-item__question {
        &:first-child {
            padding-top: 25px;
        }
        padding: 20px 10px 10px 10px;
    }

    .answer,
    .question {
        font-weight: 500;
        font-size: 16px;
        line-height: 24px;
        color: #333333;
    }
    .question {
        margin-bottom: 15px;
    }
    .selected-text-icon {
        color: #6bbd6c;
        margin-right: 10px;
    }

    .trainer-modal-content__text-settings {
        height: 250px;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }

    .trainer-modal-content__footer-button {
        margin: 5px;
    }
</style>
